import React, { useState, useEffect } from "react";
import { FiMapPin, FiMail, FiEdit2 } from "react-icons/fi";
import useStore from "@/services/store";
import api from "@/services/api";
import toast from "react-hot-toast";
import Loader from "@/components/loader";

import AboutSection from "./AboutSection";
import ExperienceSection from "./ExperienceSection";
import EducationSection from "./EducationSection";
import SkillsSection from "./SkillsSection";
import ProfileCompletion from "./ProfileCompletion";
import LanguagesSection from "./LanguagesSection";
import ResumeUpdateCard from "./ResumeUpdateCard";
import AvatarUpload from "./AvatarUpload";

export default function Profile() {
  const { user, setUser } = useStore();
  const [values, setValues] = useState({});

  useEffect(() => {
    if (user) {
      setValues(user);
    }
  }, [user]);

  const saveProfile = async (newValues) => {
    try {
      const updatedUser = { ...user, ...newValues };
      setUser(updatedUser);
      setValues((prev) => ({ ...prev, ...newValues }));

      const res = await api.put(`/user/${user._id}`, newValues);
      if (!res.ok) {
        throw new Error(res.code || "Failed to update profile");
      }
      toast.success("Profile updated");
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleSetValues = (newValues) => {
    setValues(newValues);

    // Auto-save specific fields when they change
    const fieldsToCheck = ["experiences", "education", "skills", "languages", "about"];
    fieldsToCheck.forEach((field) => {
      if (JSON.stringify(newValues[field]) !== JSON.stringify(user[field])) {
        saveProfile({ [field]: newValues[field] });
      }
    });
  };

  if (!user) return <Loader />;

  return (
    <div className="max-w-7xl mx-auto pb-10">
      {/* Profile Header */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-6">
            <AvatarUpload user={user} onSave={saveProfile} />

            <div className="space-y-1">
              <h1 className="text-2xl font-bold text-gray-900">
                {user.firstname} {user.lastname}
              </h1>
              <div className="flex flex-wrap items-center gap-4 text-sm text-gray-500">
                {/* {(user.city || user.country) && (
                  <div className="flex items-center gap-1.5">
                    <FiMapPin />
                    <span>{[user.city, user.country].filter(Boolean).join(", ")}</span>
                  </div>
                )} */}
                <div className="flex items-center gap-1.5">
                  <FiMail />
                  <span>{user.email}</span>
                </div>
              </div>
              <div className="pt-2">
                <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Actively looking</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Main Content */}
        <div className="lg:col-span-2 space-y-6">
          <AboutSection values={values} setValues={setValues} onSave={saveProfile} />
          <ExperienceSection values={values} setValues={handleSetValues} />
          <EducationSection values={values} setValues={handleSetValues} />
          <SkillsSection values={values} setValues={handleSetValues} />
        </div>

        {/* Sidebar */}
        <div className="space-y-6">
          <ResumeUpdateCard
            onSuccess={(updatedUser) => {
              setUser(updatedUser);
              setValues(updatedUser);
            }}
          />
          <ProfileCompletion values={values} />
          <LanguagesSection values={values} setValues={handleSetValues} />
        </div>
      </div>
    </div>
  );
}
